export default {
  pages: {
    key: "title",
    data: [
      {title: 'Dashboard',   url: '/admin/dashboard',      icon: 'HomeIcon', is_bookmarked: false},
      {title: 'Past Events', url: '/admin/event/past', icon: 'CheckSquareIcon', is_bookmarked: false},
      {title: "User List", url: "/admin/user/list", icon: "ListIcon", is_bookmarked: false},
    ]
  }
}
